import type { Gameweek } from '@/types';

/** Deadline is generated relative to now so the countdown always reads sensibly. */
const deadlineFromNow = (): string => {
  const deadline = new Date();
  deadline.setDate(deadline.getDate() + 2);
  deadline.setHours(deadline.getHours() + 4, deadline.getMinutes() + 18, 0, 0);
  return deadline.toISOString();
};

export const MOCK_GAMEWEEK = (): Gameweek => ({
  id: 5,
  competition: 'Premier Division',
  status: 'open',
  deadlineAt: deadlineFromNow(),
});
